<!--
    @修改人：黎柏祺
    @修改时间：2018-10-24
    @修改描述：框架升级
    @版本:v1.0.26
    --------
    @修改人：谢汉
    @修改时间：2018-07-06
    @修改描述：改版主机地图
    @版本:v1.0.18
    --------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 主机地图页
-->
<template>
<div class="hostMapping__content">
  <div class="total-wrap">
    <div class="total-title">{{$t('hostMapping.totalCount')}}</div>
    <ul class="total-hidden">
      <li class="total-each">
        <div class="total-num" v-text="totalHostNum"></div>
        <div>{{$t('hostMapping.machinCount')}}</div>
      </li>
      <li class="total-each li-margin">
        <div class="total-num" v-text="totalPowerOnNum"></div>
        <div>{{$t('hostMapping.powerOn')}}</div>
      </li>
      <li class="total-each">
        <div class="total-num" v-text="totalPowerOffNum"></div>
        <div>{{$t('hostMapping.powerOff')}}</div>
      </li>
    </ul>
  </div>
  <div class="total-wrap">
    <div class="total-title">{{$t('hostMapping.generatorRoom')}}</div>
    <div class="room-wrap" v-for="(item,index) in generatorRoomList" :key="index">
      <div class="room-title">
        <span v-text="item.siteName"></span>
        <span class="room-check" @click="checkRoom(item)">{{$t('hostMapping.check')}}</span>
      </div>
      <ul class="total-hidden">
        <li class="room-each" style="border-right: 1px solid #ddd">
          <div class="total-num" v-text="item.total"></div>
          <div>{{$t('hostMapping.machinCount')}}</div>
        </li>
        <li class="room-each li-margin" style="border:1px solid #ddd; border-top: 0; border-bottom: 0;">
          <div class="total-num" v-text="item.powerOn"></div>
          <div>{{$t('hostMapping.powerOn')}}</div>
        </li>
        <li class="room-each" style="border-left: 1px solid #ddd">
          <div class="total-num" v-text="item.powerOff"></div>
          <div>{{$t('hostMapping.powerOff')}}</div>
        </li>
      </ul>
    </div>
    <div v-show="generatorRoomList.length == 0" style="text-align: center;">{{$t('hostMapping.noData')}}</div>
  </div>
</div>
</template>
<script>
  import hostMappingBiz from '@/logic/intelligentMonitor/hostMappingBiz.js'
  export default {
    data () {
      return {
        lan: {},
        generatorRoomList: [],
        totalHostNum: 0,
        totalPowerOnNum: 0,
        totalPowerOffNum: 0
      }
    },
    methods: {
      e_restData () {
        this.generatorRoomList = []
        this.totalHostNum = 0
        this.totalPowerOnNum = 0
        this.totalPowerOffNum = 0
      },
      e_searchSite () {
        hostMappingBiz.getSiteMap().then((data) => {
          this.e_restData()
          let arr = data
          arr.map((item) => {
            if (item.siteName && item.siteCode) {
              this.totalHostNum += item.total
              this.totalPowerOnNum += item.powerOn
              this.totalPowerOffNum += item.powerOff
              this.generatorRoomList.push(item)
            }
          })
        })
      },
      checkRoom (roomData) {
        this.$router.push({ path: '/home/hostMapping/hostMappingDetail', query: { siteCode: roomData.siteCode } })
      }
    },
    mounted () {
      this.e_searchSite()
    },
    watch: {

    }
  }
</script>
<style scoped>
  .hostMapping__content .total-hidden {
      overflow: hidden; 
  }
  .hostMapping__content li {
      float: left;
      margin: 0px;
      padding: 0px;
  }
  .hostMapping__content .li-margin {
      margin: 0 2%;
  }
  .hostMapping__content .total-wrap {
      margin: 15px 0;
      
  }
  .hostMapping__content .total-wrap .total-title {
      font-size: 20px;
      font-weight: bolder;
      margin-bottom: 15px;
  }
  .hostMapping__content .total-wrap .total-each {
      display: inline-block;
      width: 32%;
      text-align: center;
      background: #e5f0ff;
      height: 110px;
      line-height: 35px;
      padding: 20px 0;
      border: 1px solid #ddd;
      border-radius: 2px;
      box-sizing: border-box;
  }
  .hostMapping__content .total-wrap .total-num {
      font-size: 24px;
      font-weight: bolder
  }
  .hostMapping__content .total-wrap .room-wrap {
      width: 100%;
      border: 1px solid #ddd;
      border-radius: 2px;
      margin-bottom: 30px;
  }
  .hostMapping__content .total-wrap .room-wrap .room-title {
      padding: 10px;
      border-bottom: 1px solid #ddd;
  }
  .hostMapping__content .total-wrap .room-wrap .room-each {
      display: inline-block;
      width: 32%;
      height: 110px;
      text-align: center;
      background: #e5f0ff;
      line-height: 35px;
      padding: 20px 0;
      box-sizing: border-box;
  }
  .hostMapping__content .total-wrap .room-wrap .room-check {
      color: #3385ff;
      float: right;
      cursor: pointer;
  }
</style>